module.exports = __webpack_public_path__ + "static/media/piper-1-no-line.f3d046f7.svg";